import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "M7.125 12q-2.044 0-3.459-1.416Q2.252 9.168 2.25 7.125q0-2.044 1.416-3.459Q5.082 2.252 7.125 2.25q2.044 0 3.459 1.416T12 7.125a4.57 4.57 0 0 1-.975 2.85l4.2 4.2a.71.71 0 0 1 .206.525.71.71 0 0 1-.206.525.71.71 0 0 1-.525.206.71.71 0 0 1-.525-.206l-4.2-4.2a4.571 4.571 0 0 1-2.85.975m0-1.5q1.407 0 2.391-.985.985-.984.984-2.39 0-1.405-.985-2.391-.984-.985-2.39-.984-1.405 0-2.391.985-.985.984-.984 2.39 0 1.407.985 2.391.984.985 2.39.984"
    }, null, -1)
  ]))]))
}
export default { render: render }